<template>
    <div>
        <form @submit.prevent="validate" v-if="!isFormSubmitted">
            <p>We can email you when this is available!</p>
            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <input type="email" placeholder="Enter email..." v-model="email">
                </div>
                <div class="col-md-4 col-sm-12 form-grp">
                    <label for="quantity">Qty: </label>
                    <input id="quantity" type="number" placeholder="Quantity" v-model="quantity" min="1">   
                </div>
                <div class="col-md-2 col-sm-12">
                    <button class="btn btn-primary btn-hover" :disabled="email ? false : true">Go</button>
                </div>
            </div>
        </form>
        <p id="success" v-if="isFormSubmitted">Thank you! Your request has been received.</p>
        <RecaptchaModal :sitekey="sitekey"></RecaptchaModal>
    </div>
</template>
<script>

import RecaptchaModal from "./out-of-stock-recaptcha-modal";

export default {
    components: {
        RecaptchaModal
    },
    props: {
        'sitekey': {
            type: String
        },
        'item': {
            type: Object
        },
        'productId': {
            type: String
        },
    },
    data() {
        return {
            email: null,
            quantity: 1,
        }
    },
    mounted() {
        this.$store.commit("outofstock/hideAddToCartButton");
    },
    methods: {
        validate() {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(this.email)) 
                alert('Please enter a valid email address!')
            else  
                this.signup();
        },
        signup() {
           this.$store.commit("outofstock/showModal", {
               email: this.email,
               quantity: this.quantity,
               culture: window.culture,
               product: this.item.displayname,
               itemid: this.item.itemid,
               internalid: this.item.internalid,
               components: this.getAllComponents(),
               productId: this.productId,
           });
        },
        getAllComponents() {
            return this.item.custitem_rr_json_string_link_itemgrp;
        },
    },
    computed: {
        isFormSubmitted() {
            return this.$store.getters["outofstock/isFormSubmitted"];
        },
    }
};
</script>

<style scoped>
    p {
        font-weight: bold;
        padding-top: .5rem;
        padding-bottom: .5rem;
    }

    p#success {
        padding-top: 2rem;
        padding-bottom: 2rem;

    }

    div > form {
        padding-top: 1rem;
        padding-bottom: 1rem;
    }

    input {
        margin-bottom: 10px;
        width: 100%;
        height: 40px;
        line-height: 2;
        padding: 10px;
        text-align: center;
    }

    input[type='number'] {
        width: 50%;
    }

    button {
        border: 1px solid #B65B00;
        color: #FFF;
        text-align: center;
        background:#B65B00;
        width: 100%;
        height: 40px;
        display: inline-flex;
        align-items: center; 
        justify-content: center;
    }

    .form-grp {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
    }

    label {
        padding-left: .5rem;
    }

    @media only screen and (max-width: 768px) {
       .form-grp {
           flex-direction: column;
       }
       label, input[type='number'] {
           width: 100%;
       }
    }
</style>
